import React from 'react';
import { styled } from '@mui/material/styles';
import { TextField, Box, Tooltip } from '@mui/material';
import {
  AddCircleOutline as AddCircleOutlineIcon,
  HighlightOff as HighlightOffIcon,
} from '@mui/icons-material';
import { Selection } from 'components';
import ApiServices from 'services';
import { NumberFormatCustom } from 'components';

const InputItem = React.forwardRef(
  (
    { item, index, onDelete, onAdd, values, setValues, error, disabledField, leaseSpaceList },
    ref,
  ) => {
    const [leasingPriceId, setLeasingPriceId] = React.useState('');
    const [price, setPrice] = React.useState(0);
    const [unitCode, setUnitCode] = React.useState('');
    const [vat, setVat] = React.useState(0);

    React.useImperativeHandle(ref, () => ({
      getAlert() {
        alert('getAlert from Child');
      },
    }));
    React.useEffect(() => {
      setLeasingPriceId(item?.leasingPriceId);
      setPrice(item.price);
      setUnitCode(item?.unitCode);
      setVat(item?.vat);
    }, [item]);

    const onChangeLeaseSpace = React.useCallback(
      (e) => {
        setLeasingPriceId(e.target.value);
        setValues((prev) => {
          prev[index].leasingPriceId = e.target.value;
          return [...prev];
        });
      },
      [leasingPriceId],
    );
    const onChangePrice = React.useCallback(
      (e) => {
        setPrice(+e.target.value);
        setValues((prev) => {
          prev[index].price = +e.target.value;
          return [...prev];
        });
      },
      [price],
    );
    const onChangeUnit = React.useCallback(
      (e) => {
        setUnitCode(e.target.value);
        setValues((prev) => {
          prev[index].unitCode = e.target.value;
          return [...prev];
        });
      },
      [unitCode],
    );
    const onChangeVAT = React.useCallback(
      (e) => {
        setVat(+e.target.value);
        setValues((prev) => {
          prev[index].vat = +e.target.value;
          return [...prev];
        });
      },
      [vat],
    );
    const isDisabled = !leasingPriceId || !price || !unitCode;

    return (
      <Container>
        <ContainerBody>
          <Box sx={{ width: '100%', marginRight: '10px' }}>
            <Selection
              required
              sx={{
                width: '100%',
                marginTop: 0,
                fontSize: '12px',
              }}
              sxInput={{ padding: '0px', margin: '0px' }}
              label="Leas space"
              name="serviceId"
              onChange={onChangeLeaseSpace}
              value={leasingPriceId}
              dataArrObject={leaseSpaceList}
              fieldValue="id"
              fieldView="name"
              error={!leasingPriceId}
              disabled={disabledField}
            />
            {!leasingPriceId && <ErrorText>Bắt buộc (*)</ErrorText>}
          </Box>
          <Box sx={{ width: '50%' }}>
            <StyledTextFieldPrice
              label="Đơn giá"
              variant="outlined"
              type="text"
              size="small"
              InputProps={{
                inputComponent: NumberFormatCustom,
              }}
              onChange={onChangePrice}
              value={price}
              error={!price}
              disabled={disabledField}
            />
            {!price && <ErrorText>Bắt buộc (*)</ErrorText>}
          </Box>
          <Box sx={{ width: '50%' }}>
            <Selection
              required
              sx={{
                width: '100%',
                marginTop: 0,
                fontSize: '12px',
              }}
              sxInput={{ padding: '0px', margin: '0px' }}
              label="Đơn vị"
              name="serviceId"
              onChange={onChangeUnit}
              value={unitCode}
              syncData={ApiServices.getUnits}
              fieldValue="code"
              error={!unitCode}
              disabled={disabledField}
            />
            {!unitCode && <ErrorText>Bắt buộc (*)</ErrorText>}
          </Box>
          <StyledTextField
            label="VAT"
            variant="outlined"
            type="text"
            size="small"
            InputProps={{
              inputComponent: NumberFormatCustom,
            }}
            onChange={onChangeVAT}
            value={vat}
            disabled={disabledField}
          />
        </ContainerBody>
        <ContainerAction>
          {index === values.length - 1 ? (
            <>
              <Tooltip title="Xóa" arrow>
                <ButtonWrapper
                  marginBottom={isDisabled ? '15px' : '0px'}
                  onClick={() => onDelete(index)}
                  sx={{ borderColor: 'error.main' }}
                  disabled={disabledField}
                >
                  <HighlightOffIcon sx={{ color: 'error.main' }} />
                </ButtonWrapper>
              </Tooltip>
              <Tooltip title="Thêm" arrow>
                <ButtonWrapper
                  marginBottom={isDisabled ? '15px' : '0px'}
                  onClick={onAdd}
                  sx={{ borderColor: isDisabled ? 'action.disabled' : 'success.main' }}
                  disabled={isDisabled}
                >
                  <AddCircleOutlineIcon
                    sx={{ color: isDisabled ? 'action.disabled' : 'success.main' }}
                  />
                </ButtonWrapper>
              </Tooltip>
            </>
          ) : (
            <Tooltip title="Xóa" arrow>
              <ButtonWrapper
                onClick={() => onDelete(index)}
                sx={{ borderColor: 'error.main' }}
                marginBottom={isDisabled ? '15px' : '0px'}
              >
                <HighlightOffIcon sx={{ color: 'error.main' }} />
              </ButtonWrapper>
            </Tooltip>
          )}
        </ContainerAction>
      </Container>
    );
  },
);
export default InputItem;

const StyledTextFieldPrice = styled(TextField)(({ theme }) => ({
  marginRight: '10px',
  width: '95%',
}));

const StyledTextField = styled(TextField)(({ theme }) => ({
  width: '50%',
  marginLeft: '10px',
}));
const Container = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'row',
}));
const ContainerBody = styled(Box)(({ theme }) => ({
  width: '95%',
  display: 'flex',
  flexDirection: 'row',
  marginTop: '5px',
}));
const ContainerAction = styled(Box)(({ theme }) => ({
  width: '5%',
  display: 'flex',
  flexDirection: 'row',
}));
const ButtonWrapper = styled(Box)(({ theme, disabled = false, marginBottom = '10px' }) => ({
  marginBottom,
  pointerEvents: disabled ? 'none' : 'all',
  paddingInline: '6px',
  display: 'flex',
  alignItems: 'center',
  cursor: 'pointer',
  borderRadius: '0 4px 4px 0',
}));
const ErrorText = styled('div')(({ theme }) => ({
  color: 'red',
  fontSize: '12px',
  marginLeft: '10px',
}));
